
// todo - this would be replaced with domain name later
// export const API_URL = "http://localhost:8000";
export const API_URL = process.env.REACT_APP_API_URL;

// export const SITE_KEY = "6LfGiS8qAAAAAJiYCwx5JPo2mlqKrvWfPqybKt1Y"
export const SITE_KEY = "6Lc4y6QqAAAAALnb9NTebljWLVaOxkEL-_Xf5smb"
